<template>

        <v-dialog
                scrollable
                v-model='dialog'
                max-width='420'
        >
            <v-card>
                <v-card-title tag='h6' class='break-word'>املاک شما</v-card-title>
                <v-divider></v-divider>
                <v-card-text class='pa-5' v-if='!loadingMyUnits && owner_units.length > 0'>
                    <Unit :unit="unit" v-for='unit in owner_units'
                          :key='unit._id' :to="{name: 'newAd', query: { unit_id: unit._id }}"></Unit>

                </v-card-text>
                <v-card-text class='pa-5' v-if='!loadingMyUnits && owner_units.length === 0'>
                    <div>هیچ ملکی به نام شما ثبت نشده است</div>
                </v-card-text>
                <div v-if='loadingMyUnits' class='text-center'>
                    <h4>لطفا صبر کنید...</h4>
                </div>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn
                            block
                            color='primary'
                            :to='{name:"newAd"}'
                    >
                        آگهی جدید
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

</template>

<script>
    import axios from 'axios';
    import {mapState} from 'vuex';
    import Unit from '@/components/Unit';

    export default {
        name: 'SelectUnitForCreateAds',
        components:{
            Unit
        },
        props: {
            chooseUnitDialog:Boolean
        },
        model:{
            prop:'chooseUnitDialog',
            event:'change'
        },
        data() {
            return {
                source: axios.CancelToken.source(),
                owner_units: [],
                loadingMyUnits: false,
            }
        },
        watch:{
            async dialog(v){
                if(v){
                    await this.fetchMyUnits();
                }
                this.$emit('change',this.dialog);
            }
        },
        methods: {
            async fetchMyUnits() {
                this.loadingMyUnits = true;
                await axios
                    .get('/api/users/me/owner_units', {cancelToken: this.source.token})
                    .then(res => {
                        if (res.data.units.length > 0) {
                            this.dialog = true;
                            this.owner_units = res.data.units;
                        } else {
                            this.$router.push({name: 'newAd'});
                        }
                        this.loadingMyUnits = false;

                    })
                    .catch(err => {
                        this.loadingMyUnits = false;
                        console.error(err);
                    });
            },
        },
        computed: {
            dialog: {
                get: function() {
                    return this.chooseUnitDialog
                },
                set: function(value) {
                    this.$emit('change',value);
                }
            },
            ...mapState(['public_url', 'translate'])
        },
    };
</script>

<style scoped lang='scss'>

</style>